
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sekiwtiutnikmdbpiufi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNla2l3dGl1dG5pa21kYnBpdWZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUzOTI0MzIsImV4cCI6MjA1MDk2ODQzMn0.OYCXJ_wPnVWdgSeTHGc_fHaHP5pHhsGBt1TN2zeLz0M";

// Enhanced client configuration with more robust session handling
const client = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true,
    storageKey: 'testera_auth_token',
    flowType: 'pkce',
    debug: true, // Enable debug mode to help troubleshooting
    storage: {
      getItem: (key) => {
        try {
          const item = localStorage.getItem(key);
          console.log(`[Auth Storage] Getting auth item: ${key}, exists:`, !!item);
          return item ? JSON.parse(item) : null;
        } catch (error) {
          console.error(`[Auth Storage] Error getting auth item: ${key}`, error);
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          console.log(`[Auth Storage] Setting auth item: ${key}`, value);
          localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
          console.error(`[Auth Storage] Error setting auth state in localStorage:`, error);
        }
      },
      removeItem: (key) => {
        try {
          console.log(`[Auth Storage] Removing auth item: ${key}`);
          localStorage.removeItem(key);
        } catch (error) {
          console.error(`[Auth Storage] Error removing auth state from localStorage:`, error);
        }
      },
    },
  },
});

export const supabase = client;
